var code = {
  // 套餐
  // 条款单位
  termUnit: {
    '1': '年',
    '2': '月',
    '3': '天',
    '4': '千条'
  },
  buttonType: {
    '1': '立即购买',
    '2': '免费试用',
    '3': '预约试用',
    '5': '联系客服'
  },
  // 发票
  invoiceType: {
    '1': '普通',
    '2': '专票'
  },
  invoiceHead: {
    '1': '企业',
    '2': '个人',
    '3': '其他'
  },
  invoiceStatus: {
    '0': '待处理',
    '1': '处理中',
    '2': '开票成功',
    '3': '已通过',
    '4': '已撤销',
    '5': '已拒绝'
  },
  invoiceNature: {
    '1': '电子发票',
    '2': '纸质发票'
  },
  invoiceContent: {
    '1': '技术服务费'
  },
  // 企业认证、营业执照审核状态
  auditStatus: {
    0: '待审核',
    1: '通过',
    2: '驳回'
  },
  // 订单
  // 缴费类型
  orderType: {
    '1': '新购',
    '2': '续费',
    '3': '退货'
  },
  // 服务类型
  appCategory: {
    '1': '套餐',
    '2': '增值服务',
    '3': '扩容服务'
  },
  // 支付方式
  paymentMode: {
    'scan_pay': '扫码支付',
    'scan_collect': '扫码收款',
    'transfer_accounts': '转账',
    'wallet_balance': '钱包余额'
  },
  orderStatus: {
    '1': '待付款',
    '2': '付款成功',
    '3': '付款失败',
    '4': '订单过期',
    '5': '取消订单',
    '6': '退款'
  },
  // 公司业务状态
  companyStatus: {
    '1': '未开通试用阶段',
    '2': '使用中',
    '3': '已过期',
    '4': '禁用'
  },
  gradeType: {
    '1': '标准版',
    '2': '高级版',
    '3': '旗舰版'
  },
}

export default code